import { render, staticRenderFns } from "./receivable-list.vue?vue&type=template&id=336c3475&"
import script from "./receivable-list.vue?vue&type=script&lang=js&"
export * from "./receivable-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports